export default "__VITE_ASSET__gNpmIs7o__"